export const BasicSliderData = [
  {
    text: "Use the ",
    code: ".range-slider ",
  },
  {
    text: "class. and Cion used Ion range slider.",
    code: "[https://www.npmjs.com/package/react-range]",
  },
];
